import { render, staticRenderFns } from "./BaseResourcePropertyTooltip.vue?vue&type=template&id=60fc3fc9"
import script from "./BaseResourcePropertyTooltip.vue?vue&type=script&lang=ts"
export * from "./BaseResourcePropertyTooltip.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports